import {getUrlPurePathName} from '@/utils';

export interface managerItemProps {
  key: string;
  to: string;
  label: string;
  isPrimitive?: boolean;
  includePath?: string[];
}
export interface clientItemProps {
  group: boolean;
  title: string;
  key: string;
  children: managerItemProps[];
}
// 管理端
export const managerSideBar: managerItemProps[] = [
    {
        key: '/idaas/#/idaas/project/list',
        to: '/idaas/#/idaas/project/list',
        includePath: ['/idaas/#/idaas/project/create'],
        isPrimitive: true,
        label: '我的企业',
    },
    {
        key: '/idaas/personal-center',
        to: '/idaas/personal-center',
        label: '个人中心',
    },
    {
        key: '/idaas/other-login',
        to: '/idaas/other-login',
        label: '第三方登录',
    },
    {
        key: '/idaas/more-provider',
        to: '/idaas/more-provider',
        label: '多因素认证',
    },
];

// 公有云管理端
export const publicCloudManager: managerItemProps[] = [
    {
        key: '/idaas/#/idaas/project/list',
        to: '/idaas/#/idaas/project/list',
        includePath: ['/idaas/#/idaas/project/create'],
        isPrimitive: true,
        label: '项目',
    },
];
// 管理端-我的企业
export const managerMyCompanySideBar: Array<clientItemProps | managerItemProps> = [
    {
        key: '/idaas/#/idaas/project/detail',
        to: '/idaas/#/idaas/project/detail',
        label: '概览',
        includePath: ['/idaas/#/idaas/overView/user'],
        isPrimitive: true,
    },
    {
        group: true,
        title: '用户',
        key: 'user',
        children: [
            {
                key: '/idaas/#/idaas/user/list',
                to: '/idaas/#/idaas/user/list',
                label: '用户列表',
                includePath: [
                    '/idaas/#/idaas/user/detail',
                ],
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/organization/list',
                to: '/idaas/#/idaas/organization/list',
                label: '组织架构',
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/user/group',
                to: '/idaas/#/idaas/user/group',
                label: '用户组',
                includePath: [
                    '/idaas/#/idaas/user/operateGroup',

                ],
                isPrimitive: true,
            },
        ],
    },
    {
        group: true,
        title: '认证',
        key: 'provider',
        children: [
            {
                key: '/idaas/#/idaas/provider/list',
                to: '/idaas/#/idaas/provider/list',
                label: '认证源',
                includePath: [
                    '/idaas/#/idaas/provider/components/detail',
                    '/idaas/#/idaas/provider/detail',
                ],
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/mfa/detail',
                to: '/idaas/#/idaas/mfa/detail',
                label: '多因素认证',
                isPrimitive: true,
            },
        ],
    },
    {
        group: true,
        title: '应用',
        key: 'application',
        children: [
            {
                key: '/idaas/#/idaas/application/list',
                to: '/idaas/#/idaas/application/list',
                includePath: [
                    '/idaas/#/idaas/application/custom/detail',
                    '/idaas/#/idaas/application/detail',
                ],
                label: '应用列表',
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/application/library/list',
                to: '/idaas/#/idaas/application/library/list',
                label: '应用库',
                isPrimitive: true,
            },
        ],
    },
    {
        group: true,
        title: '权限',
        key: 'permission',
        children: [
            {
                key: '/idaas/#/idaas/permission/list',
                to: '/idaas/#/idaas/permission/list',
                label: '权限配置',
                includePath: [
                    '/idaas/#/idaas/permission/detail',
                ],
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/policy/list',
                to: '/idaas/#/idaas/policy/list',
                label: '权限管理',
                isPrimitive: true,
            },
        ],
    },
    {
        group: true,
        title: '审计',
        key: 'auditing',
        children: [
            {
                key: '/idaas/#/idaas/audit/admin/list',
                to: '/idaas/#/idaas/audit/admin/list',
                label: '管理员行为',
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/audit/user/list',
                to: '/idaas/#/idaas/audit/user/list',
                label: '用户行为',
                isPrimitive: true,
            },
        ],
    },
    {
        group: true,
        title: '设置',
        key: 'setting',
        children: [
            {
                key: '/idaas/#/idaas/setting/detail',
                to: '/idaas/#/idaas/setting/detail',
                label: '安全设置',
                isPrimitive: true,
            },
            {
                key: '/idaas/#/idaas/setting/individuation',
                to: '/idaas/#/idaas/setting/individuation',
                label: '个性化设置',
                isPrimitive: true,
            },
        ],
    },
];
// 用户端
export const clientSideBar: clientItemProps[] = [
    {
        group: true,
        title: '应用',
        key: 'sub-app',
        children: [
            {
                key: '/idaas/my-app',
                to: '/idaas/my-app',
                label: '我的应用',
            },
        ],
    },
    {
        group: true,
        title: '设置',
        key: 'sub-set',
        children: [
            {
                key: '/idaas/personal-center',
                to: '/idaas/personal-center',
                label: '个人中心',
            },
            {
                key: '/idaas/other-login',
                to: '/idaas/other-login',
                label: '第三方登录',
            },
            {
                key: '/idaas/more-provider',
                to: '/idaas/more-provider',
                label: '多因素认证',
            },
            {
                key: '/idaas/my-log',
                to: '/idaas/my-log',
                label: '我的日志',
            },
        ],
    },
];
export function openMenu(location: Location, sideBarArr: Array<managerItemProps | clientItemProps>) {
    const key = getUrlPurePathName(location);
    const openKeys: string[] = [];
    const selectedKeys: string[] = [];
    sideBarArr.forEach(groupItem => {
        if ((groupItem as clientItemProps).group) {
            const item = (groupItem as clientItemProps).children
                .find(item => item.key === key || item.includePath?.includes(key));
            if (item) {
                openKeys.push(groupItem.key);
                selectedKeys.push(item.key);
            }
        } else if ((groupItem as managerItemProps).key === key
        || (groupItem as managerItemProps).includePath?.includes(key)) {
            selectedKeys.push(groupItem.key);
        }
    });
    return {
        openKeys,
        selectedKeys,
    };
}

